<script lang="ts">
	//UI
	import NoticeList from "@hitit/hub/src/v7/views/NoticeList.svelte";
	import Notice from "@hitit/hub/src/v7/views/Notice.svelte";
	//Utils
	import { Router, Route } from "svelte-routing";
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do
</script>

<Router>
	<Route path="/">
		<NoticeList />
	</Route>
	<Route path="/:id" let:params>
		<Notice noticeId={params.id || ""} />
	</Route>
</Router>

<style lang="scss">
</style>
